import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { StaticImage } from 'gatsby-plugin-image'
import freeShipping from '../../../utils/freeShipping'
import unitName from '../../../utils/unitName'
import {
  CustomLogo,
  PiecePrice,
  SavePrice,
  StartPrice,
  compareRow,
  strikeThrough,
  unitPrice,
} from './compare-price.module.scss'

const ComparePrice = ({ price, product }) => {
  const unit = unitName(product.productType)

  return (
    <Row className={compareRow}>
      <Col className={StartPrice}>
        <h6 className='price-text'>Our Sale Price</h6>

        {price.comparePriceSqft ? (
          <React.Fragment>
            <div className={PiecePrice}>
              <strong>
                ${price.priceSqft} <small>/Sqft</small>
              </strong>
              <br />

              <span className={strikeThrough}>
                ${price.comparePriceSqft} /sqft
              </span>
            </div>
          </React.Fragment>
        ) : null}
        <React.Fragment>
          <div className={PiecePrice}>
            <strong>
              <span>${price.price.toFixed(2)}</span>
              <small> /{unit.singular}</small>
            </strong>
            <br />
            <span className={strikeThrough}>
              ${price.comparePrice} /{unit.singular}
            </span>
          </div>
        </React.Fragment>
      </Col>
      <Col className={SavePrice}>
        <h6>Your Savings</h6>
        <strong>${price.savingSqft}</strong>
        {/* <span>&nbsp;&nbsp;(25% Off)</span> */}
        <br />
        {/* {freeShipping(product) ? (
          <StaticImage
            src='../../../assets/images/free4u.png'
            alt='free-shipping-logo'
            objectFit='contain'
            width={120}
          />
        ) : null} */}
        <div>
          <a href='/return-policy/' target='_blank'>
            <StaticImage
              src='../../../assets/images/Custom4U.png'
              className={CustomLogo}
              alt='free-shipping-logo'
              objectFit='contain'
            />
          </a>
        </div>
      </Col>
    </Row>
  )
}

export default ComparePrice
